import { useEffect, useState } from 'react';

/** How long a started run may go without its host saying where to connect before the page stops waiting. */
export const START_STALL_MS = 30_000;

/**
 * Whether a start has waited past `stallMs` for the host (`party:ready`
 * never arrived). The gathering then drops the entry flash and offers a way
 * back instead of a white screen with no way out.
 */
export function useIsStartStalled(isStarting: boolean, stallMs: number = START_STALL_MS): boolean {
    const [isStalled, setIsStalled] = useState(false);
    useEffect(() => {
        setIsStalled(false);
        if (!isStarting) {
            return undefined;
        }
        const timer = setTimeout(() => setIsStalled(true), stallMs);
        return () => clearTimeout(timer);
    }, [isStarting, stallMs]);
    return isStarting && isStalled;
}
